import { defineMessages } from 'react-intl'

const scope = `procurify.components.Breadcrumbs`

export default defineMessages({
  navAriaLabel: {
    id: `${scope}.navAriaLabel`,
    defaultMessage: 'Breadcrumbs',
  },
})
